import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/emergency-medicine-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function EmergencyMedicine () {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.department_name === "Emergency Medicine & Trauma Care");

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

      <Navbar />

      <section className="page-section">
          <div className="section-content">
              <p className='page-heading'>Emergency Medicine & Trauma Care</p>

              <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                  <p className="page-subtitle">
                      Advanced Emergency Medical Treatments and Trauma 
                      <br/>
                      Interventions for Critical Health Emergencies.
                  </p>
              </div>

              <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                  <p className="page-subtitle">
                      Advanced Emergency Medical Treatments and Trauma Interventions for Critical Health Emergencies.
                  </p>
              </div>

              <div className="page-box">
                  <div className="box-content">
                      <p>Caritas Matha Hospital's Emergency Medicine & Trauma Care department is dedicated to providing urgent medical care with efficiency and compassion. Our specialized team of healthcare professionals is equipped to handle a wide range of medical emergencies and traumatic injuries. Using advanced technologies and adhering to stringent protocols, we ensure swift and effective treatment.</p>
                  </div>
                  <div className="box-image">
                      <img src={BannerImage} alt="Emergency Medicine Banner"/>
                  </div>
              </div>
          </div>
      </section>
      <section className="dept-section">
        <div
          ref={sidebarRef}
          className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
        >
          {["overview", "treatment", "facilities", "doctors"].map((section) => (
            <p
              key={section}
              className={`title ${activeSection === section ? "active" : ""}`}
              onClick={() => scrollToSection(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
              {activeSection === section && (
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="chevron-icon"
                />
              )}
            </p>
          ))}
        </div>
        <div ref={contentRef} className="contents">
          <div ref={sectionsRef.overview} className="overview-content">
            <p className="content-heading">Overview</p>
            {/* Overview content here */}
            <p>The Emergency Care unit at Caritas Matha Hospital offers comprehensive care for all medical emergencies, available 24/7. Our dedicated team of emergency physicians and expert doctors from all major specialties ensures that patients receive prompt, high-quality care in critical situations.</p>

            <p>We understand that emergencies can be stressful and overwhelming, which is why our team is trained to provide not only medical expertise but also compassionate support to patients and their families. From the moment a patient arrives, they are met with swift triage, efficient diagnostics, and a multidisciplinary approach to treatment, ensuring that they receive the most appropriate and timely care.</p>

            <p>In addition to our medical services, we prioritize continuous improvement and education. Our staff regularly participates in training programs and simulations to stay updated on the latest advancements in emergency medicine. This commitment to excellence ensures that our patients benefit from cutting-edge treatments and protocols, making Caritas Matha Hospital's Emergency Care unit a leader in emergency medical services.</p>

          </div>
          <div ref={sectionsRef.treatment} className="treatment-content">
            <p className="content-heading">Treatment</p>
            {/* Treatment content here */}

            <ul>
            
              <li>
                  <span className="subtitle">Immediate Care : </span> Our emergency unit is equipped to handle a wide range of medical emergencies, from minor injuries to life-threatening conditions.
              </li>
              <br/>

              <li>
                  <span className="subtitle">Multidisciplinary Approach : </span> Emergency care is supported by specialists from all major fields, including cardiology, neurology, orthopaedics, and more.
              </li>
              <br/>

              <li>
                  <span className="subtitle">Advanced Diagnostics : </span> Rapid access to advanced diagnostic tools such as X-rays, CT scans, and laboratory tests for quick and accurate assessment.
              </li>
              <br/>
            
              <li>
                  <span className="subtitle">Trauma Care : </span> Specialized trauma care for accidents, falls, and other urgent injuries.
              </li>
              <br/>

              <li>
                  <span className="subtitle">Cardiac Emergencies : </span> Immediate treatment for heart attacks, arrhythmias, and other cardiac conditions.
              </li>
              <br/>

              <li>
                  <span className="subtitle">Neurological Emergencies : </span> Swift intervention for strokes, seizures, and other neurological crises.
              </li>
              <br/>

              <li>
                  <span className="subtitle">Paediatric Emergencie : </span> Dedicated paediatric emergency care for infants, children, and adolescents.
              </li>
              <br/>

              <li>
                  <span className="subtitle">Triage System : </span> Efficient triage system to prioritize and manage patient flow based on the severity of their condition.
              </li>
              <br/>

            </ul>

          </div>
          <div ref={sectionsRef.facilities} className="facilities-content">
            <p className="content-heading">Facilities</p>
            {/* Facilities content here */}
            
            <p>
                <span className="subtitle">24/7 Availability : </span>
                <br />
                Our emergency unit is open around the clock, every day of the year, ensuring that patients receive timely care whenever they need it.
            </p> 

            <p>
                <span className="subtitle">State-of-the-Art Equipment : </span>
                <br />
                Equipped with the latest medical technology to handle all types of emergencies effectively.
            </p> 

            <p>
                <span className="subtitle">Emergency Physicians : </span>
                <br />
                A team of experienced emergency physicians trained to manage critical and urgent cases.
            </p> 

            <p>
                <span className="subtitle">Specialist Support : </span>
                <br />
                On-call specialists from various departments to provide comprehensive care for complex emergencies.
            </p> 

            <p>
                <span className="subtitle">Rapid Diagnostics : </span>
                <br />
                On-site diagnostic facilities, including imaging and laboratory services, for immediate evaluation.
            </p> 

            <p>
                <span className="subtitle">Critical Care Units : </span>
                <br />
                Access to intensive care units (ICU) and operating rooms for patients requiring advanced treatment and surgeries.
            </p> 

            <p>
                <span className="subtitle">Ambulance Services : </span>
                <br />
                Fully equipped ambulances staffed by trained paramedics to provide pre-hospital care and rapid transportation.
            </p> 

          </div>

          <div ref={sectionsRef.doctors} className="doctors">
                  <p className="content-heading">Doctors</p>

                  {error && <p>{error}</p>}
                  {filteredDoctors.length > 0 ? (
                      <div className='doctorbox-container'>
                          {filteredDoctors.map(doctor => (
                            <div key={doctor.id} className="doctorbox">
                                <div className="doctor-box">
                                    <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                    <div className='doctor-details'>
                                        <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                        <p>{doctor['designation']}</p>
                                        <p>{ doctor.available_time }</p>
                                        <br/>
                                        {parseInt(doctor.appointment_enabled) === 1 && (
                                            <p>
                                                <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                    Book An Appointment <FaChevronRight />
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='arrow-section'>
                                    <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                </div>
                            </div>
                          ))}
                      </div>
                  ) : (
                      !error && <p>No doctors available in this department.</p>
                  )}
              </div>

        </div>
      </section>
      <Footer ref={footerRef} />
    </div>
  );
}

export default EmergencyMedicine;
